/**
 * Generated with @muse/import-icons
 * Do not edit directly
 */

import { createIcon } from '../lib/create-icon';

export const TrashBinIcon = createIcon(
  '0 0 20 20',
  <path
    fillRule="evenodd"
    d="M13 2a3 3 0 0 1-2.481 2.955.023.023 0 0 0 .004.045H18v2h-2l-1 11H5L4 7H2V5h7.477a.023.023 0 0 0 .004-.045A3 3 0 0 1 7 2zM7 16h2V7H7zm4 0h2V7h-2z"
    clipRule="evenodd"
  />,
);
